//Import Modules
import $ from 'jquery';

//Starts an Ambient Audio Element by Selector
//Browsers block Autoplay without a User Gesture. Navigating to a Product Page
//via Link does not count as one, so a rejected play() is retried on the first
//Interaction in the new Document.
const playAmbientSound = (selector) =>{
  const audio = $(selector).get(0);
  if(!audio){
    return;
  }
  const play = () => audio.play();
  const retryOnInteraction = () =>{
    $(document).one("pointerdown keydown", ()=>{
      play().catch(()=>{});
    });
  };
  play().catch(retryOnInteraction);
}

export {playAmbientSound};
